module.exports = __webpack_public_path__ + "img/fb.41407a65.svg";